import { useState, useEffect, useRef } from 'react';
import { DownOutlined } from '@ant-design/icons';
import {
    Button,
    Dropdown,
    message,
    Form,
    Input,
    Modal,
    Space,
    Row,
} from 'antd';
import './PlayTabs.css';
import Swal from 'sweetalert2';
import {
    create_play_chat_actionHandler,
    create_play_chat_stop_loader,
    streamPlayChatResponse,
} from '../../Redux/Actions/user/CreatePlayChatConvo';
import { FaExpandAlt } from 'react-icons/fa';
import { LuCopyCheck } from 'react-icons/lu';
import { TiThumbsDown } from 'react-icons/ti';
import { HiMiniHandThumbDown } from 'react-icons/hi2';
import { IoMenu } from 'react-icons/io5';

import { useDispatch, useSelector } from 'react-redux';
import parse from 'html-react-parser';
import generatePDF from 'react-to-pdf';
import { TypeAnimation } from 'react-type-animation';
import TypeWriter from './TypeWriter';
import { BASEURL } from '../../config';
import { PlayChat_Conversation_downvote_ActionHandler } from '../../Redux/Actions/user/PlayChatConversationDownVote';

function Chat() {
    const [form] = Form.useForm();
    const generatePDFIfChat = () => {
        if (!isEmptyChat) {
            generatePDF(targetRef, { filename: 'page.pdf' });
        } else {
            message.warning('No data/text available to generate PDF.');
        }
    };
    const items = [
        {
            label: (
                <p className='m-0' onClick={generatePDFIfChat}>
                    <svg
                        className='left'
                        xmlns='http://www.w3.org/2000/svg'
                        width='14'
                        height='16'
                        viewBox='0 0 14 16'
                        fill='none'>
                        <path
                            d='M0.507 1.60024V1.6C0.507 0.927895 0.969773 0.5 1.4 0.5H12.6C13.0332 0.5 13.5 0.93134 13.5 1.6V11.2C13.5 11.8687 13.0332 12.3 12.6 12.3H7.7H2.8H2.57312L2.42371 12.4707L0.500647 14.6685L0.507 1.60024Z'
                            stroke='black'
                        />
                    </svg>
                    <span> Download PDF</span>{' '}
                </p>
            ),
        },
        {
            type: 'divider',
        },
    ];
    const [isCopied, setIsCopied] = useState(false);
    const targetRef = useRef();
    const dispatch = useDispatch();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [ChatMessage, setChatMessage] = useState('');
    const [messages, setMessages] = useState([]);
    const [typing, setTyping] = useState(false);
    const [sessionId, setSessionId] = useState(null);
    const [chatTittle, setChatTittle] = useState('');
    const [tittle, setTittle] = useState('');
    const [isEditable, setIsEditable] = useState(false);
    const [showError, setShowError] = useState(false);
    const [streamResponse, setStreamResponse] = useState(null);
    const [isStreaming, setIsStreaming] = useState(false);
    const [isTyping, setIsTyping] = useState(false);

    const [showFullScreenImage, setShowFullScreenImage] = useState(false);
    const [showThumbdown, setShowdumbDown] = useState({});
    const [handleJosnStream, setHandleJosnStream] = useState(null);

    const toggleFullScreenImage = () => {
        setShowFullScreenImage(!showFullScreenImage);
    };
    const isEmptyChat = messages.length === 0;

    const playChatState = useSelector((state) => state.create_play_chat_data);

    const handleStreamTypingCompleted = () => {
        if (typeof handleJosnStream === 'string') {
            const jsonParts = handleJosnStream?.split('}');

            const modifiedJsonParts = jsonParts?.map((part, index) => {
                if (index < jsonParts?.length - 1) {
                    return part + '},';
                } else {
                    return part;
                }
            });

            let jsonString = modifiedJsonParts?.join('');
            jsonString = jsonString?.trim().replace(/,$/, '');
            jsonString = `[${jsonString}]`;

            try {
                const jsonResponse = JSON.parse(jsonString);
                let mergedMessage = '';
                let message_id = null;
                for (const msg of jsonResponse) {
                    if (msg.message !== null) {
                        mergedMessage += msg?.message;
                    }
                }

                for (const msg of jsonResponse) {
                    if (msg.message_id !== null) {
                        message_id = msg?.message_id;
                        break;
                    }
                }

                setMessages([
                    ...messages,
                    {
                        message: mergedMessage,
                        type: 'RESPONSE',
                        id: message_id,
                    },
                ]);
                setStreamResponse(null);
                setIsStreaming(false);
                setIsTyping(false);
            } catch (error) {
                console.error('Error parsing streamResponse as JSON:', error);
            }
        } else if (typeof streamResponse === 'object') {
            setMessages([
                ...messages,
                { message: streamResponse, type: 'RESPONSE' },
            ]);
            setStreamResponse(null);
            setIsStreaming(false);
            setIsTyping(false);
        }
    };

    const playChatStateResponse = useSelector(
        (state) =>
            state.create_play_chat_data?.create_play_chat_data?.data?.response
    );
    const userProfilePic = useSelector(
        (state) =>
            state.SettingsUserProfileData?.user_profile_data?.profile_picture
    );

    const dataHistory = useSelector(
        (state) =>
            state.create_play_view_history_data?.create_play_view_history_data
                ?.data
    );

    const isChatDOcument = useSelector(
        (state) => state.chatDocument.isChatDocument
    );

    const dataHistoryTitle = useSelector(
        (state) =>
            state.create_play_view_history_data?.create_play_view_history_data
                ?.data?.session?.title
    );

    const down_voteData = useSelector(
        (state) => state.PlayChat_Down_voteData?.down_vote_data?.data
    );

    const handleInputSave = () => {
        setChatTittle(chatTittle);
    };

    const handleInputKeyUp = (e) => {
        if (e.key === 'Enter') {
            if (e.target.placeholder === 'Output Name') {
                e.preventDefault();
                handleInputSave();
                setIsEditable(false);
            }
        }
    };

    const handleInputBlur = () => {
        handleInputSave();
        setIsEditable(false);
    };
    const handleMouseLeave = () => {
        handleInputSave();
        setIsEditable(false);
    };

    const handleCopyClick = () => {
        const chatScreenContent = targetRef.current.innerText;
        if (chatScreenContent.trim() === '') {
            message.error('No text/Data to copy');
            return;
        }

        navigator.clipboard
            .writeText(chatScreenContent)
            .then(() => {
                setIsCopied(true);
                message.success('Copied to clipboard');
            })
            .catch((error) => {
                console.error('Error copying chat screen:', error);
                message.error('Error copying chat screen');
            });
    };

    useEffect(() => {
        if (dataHistory?.chat && !isChatDOcument) {
            setMessages([...dataHistory.chat]);
            setSessionId(dataHistory.session?.id);
            setChatTittle(dataHistoryTitle);
        }
    }, [dataHistory]);

    useEffect(() => {
        const isButtonDisabled = ChatMessage.trim() === '' || typing;
        document.getElementById('send-button').disabled = isButtonDisabled;
    }, [ChatMessage, typing]);

    // const handleImgClick = () => {
    //   setChatTittle((prevValue) =>
    //     prevValue === "Output Name" ? "" : prevValue
    //   );
    //   setIsEditable(!isEditable);
    // };

    const handleInputChange = (e) => {
        setChatTittle(e.target.value);
    };

    useEffect(() => {
        if (playChatState.create_play_chat_data?.data) {
            if (messages.length > 0) {
                setSessionId(
                    playChatState.create_play_chat_data?.data?.session?.id
                );
                setShowError(playChatState.error);
                if (playChatState.create_play_chat_data?.data?.response) {
                    setMessages([
                        ...messages,
                        playChatState.create_play_chat_data.data,
                    ]);
                }
            }
        }

        if (
            playChatState?.getStreamingData &&
            playChatState.create_play_chat_data?.data?.session?.id
        ) {
            (async () => {
                await fetchData(
                    playChatState.create_play_chat_data?.data?.session?.id
                );
            })();
        }
    }, [playChatState]);

    const fetchData = async (sessionId) => {
        setStreamResponse(null);
        const token = localStorage.getItem('token');
        const headers = new Headers({
            Authorization: 'Bearer ' + token,
        });

        try {
            const response = await fetch(
                BASEURL + 'play-chat/' + sessionId + '/stream-chat-v2',
                {
                    method: 'POST',
                    headers: headers,
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const reader = response.body.getReader();
            const textDecoder = new TextDecoder('utf-8'); // Adjust the encoding if necessary

            let receivedData = '';
            let receivedDatajson = '';

            const readChunk = async () => {
                const { value, done } = await reader.read();
                setIsStreaming(true);
                setIsTyping(true);
                dispatch(create_play_chat_stop_loader(false));
                if (done) {
                    setIsStreaming(false);
                    return;
                }

                const chunkString = textDecoder.decode(value);
                receivedData += JSON.parse(chunkString)?.message || '';
                receivedDatajson += chunkString;
                setHandleJosnStream(receivedDatajson);
                setStreamResponse(receivedData);
                // Continue reading the next chunk
                readChunk();
            };

            // Start reading chunks
            readChunk();
        } catch (error) {
            console.error('Fetch error:', error);
        }
    };

    //   useEffect(() => {
    //     try {
    //     } catch (error) {
    //       console.error("Error parsing streamResponse:", error);
    //     }
    //   }, [streamResponse]);

    const handleSendMessage = async () => {
        setMessages([...messages, { message: ChatMessage }]);
        const conversationData = {
            message: ChatMessage,
            session_id: sessionId,
            title: chatTittle === 'Output Name' ? '' : chatTittle,
        };

        try {
            const apiResponse = await dispatch(
                create_play_chat_actionHandler(conversationData)
            );
        } catch (error) {
            console.error('Error sending message:', error);
        }
        setChatMessage('');
    };

    const handleRefreshClick = () => {
        setMessages([]);
        setSessionId(null);
        setChatTittle('');
    };
    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const onFinish = (values) => {
        const conversationData = {
            message: ChatMessage,
            session_id: sessionId,
            title: chatTittle,
        };
        dispatch(create_play_chat_actionHandler(conversationData));
        form.resetFields();
        setChatTittle(values.name);
        setTittle(values.name);
        setIsModalVisible(false);
    };
    const getHistoryData =
        useSelector(
            (state) =>
                state.create_play_history_data?.create_play_history_data?.data
        ) || [];
    const dataHistoryId = useSelector(
        (state) =>
            state.create_play_view_history_data?.create_play_view_history_data
                ?.data?.session?.id
    );
    useEffect(() => {
        if (dataHistoryId !== undefined) {
            const filteredHistoryData = getHistoryData?.data?.filter(
                (item) => item?.id === dataHistoryId
            );
            if (filteredHistoryData?.length > 0) {
                setChatTittle(filteredHistoryData[0]?.title);
                setTittle(filteredHistoryData[0]?.title);
            }
        }
    }, [getHistoryData.data, dataHistoryId]);

    const copyResponseData = (msg) => {
        if (msg) {
            navigator.clipboard
                .writeText(msg)
                .then(() => {
                    message.success('Copied to clipboard');
                })
                .catch((error) => {
                    message.error('Error copying ');
                });
        }
    };

    const callThumbDowApi = (id) => {
        if (id && sessionId)
            dispatch(
                PlayChat_Conversation_downvote_ActionHandler(sessionId, id)
            );
    };

    useEffect(() => {
        if (down_voteData) {
            setShowdumbDown(down_voteData);
        }
    }, [down_voteData]);

    useEffect(() => {
        if (showThumbdown?.id) {
            setMessages((prevMessages) =>
                prevMessages?.map((message) =>
                    message?.id === showThumbdown?.id
                        ? { ...message, is_down_voted: true }
                        : message
                )
            );
        }
    }, [showThumbdown]);

    return (
        <div
            className={` mt-3 ${
                showFullScreenImage ? ' fullscreenDiv fullscreen' : ''
            }`}>
            <p className='play-first'>Access GPT-4 in a secure environment</p>
            <div
                className={'chat-upper '}
                style={
                    showFullScreenImage
                        ? {
                              position: 'relative',
                              top: '-42px',
                              height: '100vh',
                              overflow: 'auto',
                          }
                        : {}
                }>
                <div className='buttons'>
                    <div className='flex justify-content-end sub-btns '>
                        <div className='output-container'>
                            <input
                                type='text'
                                placeholder='Chat Title'
                                className='output-input'
                                onKeyUp={handleInputKeyUp}
                                onBlur={handleInputBlur}
                                onMouseLeave={handleMouseLeave}
                                value={
                                    tittle != undefined &&
                                    tittle != null &&
                                    tittle.length > 25
                                        ? `${tittle.substring(0, 25)}...`
                                        : tittle
                                }
                                disabled
                            />
                            <img
                                src='/images/output.svg'
                                className='output-img-query'
                                alt=''
                                onClick={() => setIsModalVisible(true)}
                            />
                        </div>

                        <button
                            className='msg-btn'
                            onClick={handleRefreshClick}>
                            <img
                                src='/images/refresh.svg'
                                className='output-img'
                                alt=''
                            />
                        </button>
                        <button
                            className='msg-btn  copy-btn'
                            onClick={handleCopyClick}>
                            <img
                                src='/images/copy.svg'
                                className='output-img'
                                alt=''
                            />
                        </button>

                        <div className='downlod-div dropdown-header'>
                            <img
                                src='/images/icon-dwnld.svg'
                                className='new-img me-1'
                                alt=''
                            />
                            <Dropdown
                                menu={{
                                    items,
                                }}
                                trigger={['click']}>
                                <p
                                    className='download-b'
                                    onClick={(e) => e.preventDefault()}>
                                    <Space>
                                        Download <DownOutlined />
                                    </Space>
                                </p>
                            </Dropdown>
                        </div>

                        <button
                            className='msg-btn'
                            onClick={toggleFullScreenImage}>
                            <FaExpandAlt
                                style={{
                                    height: 18,
                                    width: 20,
                                    cursor: 'pointer',
                                }}
                            />
                        </button>
                    </div>
                </div>
                <div
                    className={'message-section'}
                    ref={targetRef}
                    style={
                        showFullScreenImage
                            ? {
                                  height: 'calc(100vh - 16vh)',
                                  marginBottom: '10px',
                                  padding: '20px 10px',
                              }
                            : {}
                    }>
                    <div
                        className='chat-screen'
                        style={
                            showFullScreenImage
                                ? {
                                      overflow: 'auto',
                                      paddingLeft: '4px',
                                  }
                                : {}
                        }>
                        {messages?.map((msg, index) => (
                            <div
                                key={index}
                                className={`${msg.sender}-msg ${
                                    index == messages.length - 1
                                        ? 'last-response'
                                        : 'svooo'
                                }`}>
                                <div className='input-text '>
                                    <span className='qa-profile'>
                                        {msg.session ||
                                        msg.type === 'RESPONSE' ? (
                                            <img
                                                className='qa-pic'
                                                src='/images/QA-icon.png'
                                                alt='QA'
                                            />
                                        ) : (
                                            <img
                                                className='user-pic'
                                                src={userProfilePic}
                                                alt='User'
                                            />
                                        )}
                                    </span>
                                    <pre
                                        className='message-text '
                                        style={{ whiteSpace: 'pre-wrap' }}
                                        dangerouslySetInnerHTML={{
                                            __html: !msg.session
                                                ? parse(msg.message)
                                                : parse(msg.response),
                                        }}></pre>
                                </div>
                                {msg?.type === 'RESPONSE' && (
                                    <p className='copy-with-thmubdown'>
                                        <LuCopyCheck
                                            onClick={() =>
                                                copyResponseData(msg?.message)
                                            }
                                        />
                                        {!msg?.is_down_voted ? (
                                            <TiThumbsDown
                                                onClick={() =>
                                                    callThumbDowApi(msg?.id)
                                                }
                                            />
                                        ) : (
                                            <HiMiniHandThumbDown />
                                        )}
                                    </p>
                                )}
                            </div>
                        ))}
                        {/* <Row className='button-chat'>
                            <IoMenu />
                        </Row> */}
                        <div className='qa-msg align-items-center'>
                            {isTyping && streamResponse && (
                                <div>
                                    <div className='input-text'>
                                        <span className='qa-profile'>
                                            <img
                                                className='qa-pic'
                                                src='/images/QA-icon.png'
                                                alt='QA'
                                            />
                                        </span>
                                        <TypeWriter
                                            className='message-text typewriter'
                                            content={streamResponse}
                                            isStreaming={isStreaming}
                                            handleStreamTypingCompleted={
                                                handleStreamTypingCompleted
                                            }
                                        />
                                    </div>
                                </div>
                            )}
                            {playChatState.loader && (
                                <div className='typing-indicator'>
                                    {' '}
                                    <span>
                                        {' '}
                                        <img
                                            className='qa-pic'
                                            src='/images/QA-icon.png'
                                            // src='/images/QA_Logo_Annimation.gif'
                                            alt='QA'
                                        />
                                    </span>{' '}
                                    <span className='typewriter'>
                                        is typing....
                                    </span>
                                </div>
                            )}
                            {showError && (
                                <div className='typing-indicator'>Error</div>
                            )}
                        </div>
                    </div>

                    <div className='message-field-wrapper'>
                        <textarea
                            className='message-field'
                            placeholder='Ask a Question and press enter to submit.'
                            value={ChatMessage}
                            onChange={(e) => setChatMessage(e.target.value)}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter' && !e.shiftKey) {
                                    e.preventDefault();
                                    handleSendMessage();
                                }
                            }}
                            disabled={playChatState.loader}
                        />
                        <button
                            id='send-button'
                            className='message-send-btn'
                            onClick={handleSendMessage}>
                            <img src='/images/send-message.svg' />
                        </button>
                    </div>
                </div>
            </div>
            <Modal
                title='Update Chat Title'
                visible={isModalVisible}
                onOk={() => form.submit()}
                onCancel={handleCancel}
                className='user-management-modal'>
                <Form
                    form={form}
                    onFinish={onFinish}
                    initialValues={{ name: chatTittle }}>
                    <Form.Item
                        label='Enter Chat Title'
                        name='name'
                        rules={[
                            {
                                required: true,
                                message: 'Please input the chat title!',
                            },
                        ]}>
                        <Input
                            value={chatTittle}
                            onChange={handleInputChange}
                        />
                    </Form.Item>
                    <Form.Item>
                        <button
                            type='submit'
                            className='model-btn-submit-management'>
                            Update
                        </button>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}
export default Chat;
